const persistedKey = "team_actions";

export const prepare = () => {
  if (!localStorage.getItem(persistedKey)) {
    localStorage.setItem(persistedKey, JSON.stringify({}));
  }
};

export const get = key => {
  const existingJsonData = localStorage.getItem(persistedKey);
  const objectData = JSON.parse(existingJsonData);
  return objectData[key];
};

export const persist = (key, data) => {
  const existingJsonData = localStorage.getItem(persistedKey);
  const objectData = JSON.parse(existingJsonData);
  objectData[key] = data;
  const newJsonData = JSON.stringify(objectData);

  localStorage.setItem(persistedKey, newJsonData);
};
